import cn from 'classnames';
import { useMemo } from 'react';
import type { TVideo } from '../../../../model';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import styles from './diagramm.module.css';

type TProps = {
  chords: TVideo['chords'];
  activePosition?: number;
  onChange: (val: number) => void;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Diagramm = ({ chords, activePosition, onChange }: TProps) => {
  const transformChords = useMemo(() => {
    return chords?.reduce<{
      result: {
        position: number;
        start: string | number;
        end: string | number;
        chord: string;
      }[];
      prev: string | null;
    }>(
      (acc, item) => {
        if (acc.prev === item.chord) {
          acc.result.push({ ...item, chord: 'N' });
        } else {
          acc.prev = item.chord;
          acc.result.push(item);
        }
        return acc;
      },
      {
        result: [],
        prev: null,
      },
    ).result;
  }, [chords]);
  if (!chords) {
    return null;
  }

  return (
    <div className={styles.bg}>
      <div className={styles.wrap}>
        {transformChords?.map(({ chord, start }, i) => {
          const [x1, x2] = chord.split(':');
          const [x11, x12] = x1.split('');

          return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <div
              key={chord + i.toString()}
              className={cn(styles.cell, {
                [styles.active]: i + 1 === activePosition,
              })}
              onClick={() => {
                onChange(Number(start));
              }}
            >
              <div className={styles.chord}>
                {x11 !== 'N' ? x11 : null}
                {x12 && <small>{x12}</small>}
                <sup className={styles.small}>{x2}</sup>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
